import { DateRange } from '../common/date-range.model';
import { SaleBreezeUpModel, SaleSessionModel } from './sale-settings.model';

export interface Sale {
  saleId: number;
  saleName: any;
  startDate: string;
  endDate: string;
  saleImageUrl: string;
  catalogImageUrl: string;
  location: string;
  xrayCommenceDate: string;
  lodgeBefore: string;
  accessionPrefix: string;
  accessionExample: string;
  repositoryLocation: string;
  isEnfoceXrays: true;
  isEnfoceScopes: true;
  isEnfocePDFReports: true;
  submitStartDate: string;
  viewStartDate: string;
  viewEndDate: string;
  xRayTemplateId: number;
  termsUrl: string;
  privacyUrl: string;
  viewingHelp: string;
  studyHelp: string;
  noteHelp: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: number;
  saleTimeFactor: number;
  saleStartDate: string;
  sellingStartDate: string;
  memberId: number;
  isTermsAcceptanceRequired: boolean;
  isSubmissionAllowed: boolean;
  isViewDateApplicable: boolean;
  isSubmitDateApplicable: boolean;
  isViewingAllowed: boolean;
  isViewRequestAllowed: boolean;
  isSubmitRequestAllowed: boolean;
  saleMemberStatusId: number;
  saleMemberStatus: string;
  deniedComments: string;
  saleMemberAccessId: number;
  saleHorseCount: number;
  saleUID: string;
  lotOrHipText: string;
  xrayCommentDates?: DateRange;
  submissionDates?: DateRange;
  saleSessions: SaleSessionModel[];
  saleType: string;
  isBreezeUpSale: boolean;
  saleBreezeUps: SaleBreezeUpModel[];
}

export class SaleDeadlines {
  saleName: string;
  saleSessions: SaleSessionModel[];
  isBreezeUpSale: boolean;
  saleBreezeUps: SaleBreezeUpModel[];
}

export enum SaleTypes {
  CURRENT = 0,
  FUTURE = 1,
  PAST = -1,
}

export enum SaleTabs {
  SUBMISSIONS = 'submissions',
  REQUESTS = 'requests',
}

export class SaleSubmissions {
  id: any;
  lot?: string;
  vetName?: string;
  reviewerName?: string;
  data?: string;
  submissionDateTime: string;
  statusId: any;
  status?: string;
  comments?: string;
  saleId: any;
  horseId: any;
  lotNumber?: any;
  lotNumberSuffix?: string;
}

export enum SaleSubmissionsStatusIds {
  ALL = 0,
  APPROVED = 4,
  DENIED = 3,
  IN_REVIEW = 2,
  DRAFT = 1,
}

export class SaleSubmissionsSearchFields {
  lotNumber: string;
}

export enum SaleSubmissionsTableFields {
  LOT_NUMBER = 'lotNumber',
  VET_NAME = 'vetName',
  DATA = 'data',
  DATE_TIME = 'dateTime',
  STATUS = 'status',
  COMMENT = 'comments',
}

export enum SaleMemberStatus {
  InvitedId = -1,
  Invited = 'Accept Invitation',
  RequestId = 0,
  Request = 'Request',
  PendingId = 1,
  Pending = 'Pending',
  ReviewId = 2,
  Review = 'Review',
  ApprovedId = 3,
  Approved = 'Approved',
  DeniedId = 4,
  Denied = 'Denied',
  RequestedId = 5,
  Requested = 'Pending',
}
export class SaleRequestsSearchFields {
  memberName: string;
  emailAddress: string;
}

export enum SaleRequestsTableFields {
  VET_NAME = 'vetName',
  CLINIC_NAME = 'clinic',
  EMAIL = 'email',
  phone = 'phone',
  DATE_TIME = 'dateTime',
  ACCESS = 'access',
  STATUS = 'saleMemberStatusName',
  COMMENT = 'comment',
}
